import React, { useEffect, useState } from 'react'
import HttpClient from '../../utils/HttpClient';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import toast from 'react-hot-toast';
import nophoto from '../../Images/nophoto.jpg'
import CustomLoader from '../../CustomComponents/loader/CustomLoader';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import { Autocomplete, TextField, Chip } from "@mui/material";

const MemberBusinessListEdit = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const data = location?.state
    const initdata = {
        personName: data?.personName,
        designationID: data?.designationID,
        mobileNo: data?.mobileNo,
        telephoneNo: data?.telephoneNo,
        companyName: data?.companyName,

        companyTypeName: "",
        emailId: data?.emailId,
        password: data?.passwordView,
        emirate: data?.emirate,
        country: data?.country,

        countryName: data?.countryName,
        countryCodeMobile: data?.phone_code,
        whatsappNo: data?.whatsappNo,
        countryCodewhatsappNo: data?.whats_code,

        businessProfilePic: data?.businessProfilePic,
        businesBanner: data?.businesBanner,
        aboutBusiness: data?.aboutBusiness,
        companyTypeID: data?.companyTypeID,

        businessWebsiteLink: data?.businessWebsiteLink,
        gallery: data?.gallery,
        businessProductkeywordsId: data?.businessProductkeywordsId,
        businessProductkeywords: data?.businessProductkeywords,
        businessProductCatId: data?.businessProductCatId,
        businessProductCat: data?.businessProductCat,
        businessLocationLink: data?.businessLocationLink,

        businessLinkedInLink: data?.businessLinkedInLink,
        businessInstaLink: data?.businessInstaLink,
        businessFacebookLink: data?.businessFacebookLink,
    };
    const [NonMemberProfileAdd, setNonMemberProfileAdd] = useState(initdata);
    const [Designation, setDesignation] = useState([]);
    const [contactdetail, setContactdetail] = useState(true);
    const [showmodal, setShowmodal] = useState(false);
    const [invitationProfile, setinvitationProfile] = useState([]);
    const [Business, setBusiness] = useState([]);
    const [Country, setCountry] = useState([]);
    const [passwordChanged, setPasswordChanged] = useState(false);
    const [CountryWiseState, setCountryState] = useState([]);
    const [isUploadingLogo, setIsUploadingLogo] = useState(false)
    const [isUploadingBusinesBanner, setIsUploadingBusinesBanner] = useState(false)

    useEffect(() => {
        getDesignation();
        getBuisinessType();
        getCountry();
        getCompanyTypeWiseServices(NonMemberProfileAdd?.companyTypeID)
        getBusinessKeywords()
    }, []);

    useEffect(() => {
        getState();
    }, [NonMemberProfileAdd.country]);


    // bcrypt passwrd
    // useEffect(() => {
    //     if (data?.token && !passwordChanged) {
    //         const decoded = jwtDecode(data.token);
    //         setNonMemberProfileAdd((prev) => ({ ...prev, password: decoded?.password }));
    //     }
    // }, [data?.token, passwordChanged]);


    //Designation
    const getDesignation = async () => {
        const res = await HttpClient.requestData("view-designation", "GET", {});

        if (res && res?.status) {
            setDesignation(res?.data);
        }
    };
    useEffect(() => {
        if (NonMemberProfileAdd?.companyTypeID) {
            const data = Business?.filter(
                (item) => item?._id === NonMemberProfileAdd?.companyTypeID
            );
            setNonMemberProfileAdd((prev) => ({
                ...prev,
                companyTypeName: data?.[0]?.type,
            }));
        }
    }, [NonMemberProfileAdd?.companyTypeID]);
    // country name
    useEffect(() => {
        const countryName = Country.filter((item) => item?._id === NonMemberProfileAdd.country)
        setNonMemberProfileAdd(prev => ({ ...prev, "countryName": countryName?.[0]?.name }));
    }, [NonMemberProfileAdd.country]);
    //typeof business
    const getBuisinessType = async () => {
        const res = await HttpClient.requestData("view-companyType", "GET", {});

        if (res && res?.status) {
            setBusiness(res?.data);
        }
    };
    //country
    const getCountry = async () => {
        const res = await HttpClient.requestData("countries", "GET", {});

        if (res && res?.status) {
            setCountry(res?.data);

        }
    };
    //state
    const getState = async () => {
        const res = await HttpClient.requestData(
            "countrywise-state/" + NonMemberProfileAdd.country || data.country,
            "GET",
            {}
        );

        if (res && res?.status) {
            setCountryState(res?.data?.[0]?.states);
        }
    };

    //handlechange
    const handleChange = (e) => {
        const { name, value } = e.target;

        setNonMemberProfileAdd((prev) => ({ ...prev, [name]: value }));
    };
    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        // Ensure only positive numbers are entered
        // const newValue = Math.max(0, parseInt(value));

        setNonMemberProfileAdd((prev) => ({ ...prev, [name]: value }));
    };

    // handle sublit 
    const handleSubmit = async (e) => {
        e.preventDefault();
        const dataEdit = {
            ...NonMemberProfileAdd,
            gallery: NonMemberProfileAdd.gallery,
            businessProductCat: selectedOptions.map((item) => item.label),
            businessProductCatId: selectedOptions.map((item) => item.value),
            businessProductkeywords: selectedKeywordOptions.map((item) => item.keyword),
            businessProductkeywordsId: selectedKeywordOptions.map((item) => item._id),
        };

        const res = await HttpClient.requestData("user/" + data._id, "PUT", dataEdit)
        if (res && res?.status) {
            toast.success("Updated Succesfully")
            navigate("/member-business-list")
        }
        else {
            toast.error(res?.msg)
        }

    }

    // select the Image
    const handleUpload = async (e) => {
        const { name, files } = e.target;
        name === "businessProfilePic" ? setIsUploadingLogo(true) : name === "businesBanner" && setIsUploadingBusinesBanner(true)
        if (files && files.length > 0) {
            // File is selected, perform image upload
            const formData = new FormData();
            formData.append("image", files[0]);
            const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                // Update state with the URL of the uploaded image

                setNonMemberProfileAdd(prev => ({
                    ...prev,
                    [name]: res?.data?.url
                }));
                name === "businessProfilePic" ? setIsUploadingLogo(false) : name === "businesBanner" && setIsUploadingBusinesBanner(false)
            }
        }
    };

    const editGallery = (e, item) => {
        e.preventDefault()
        setUpdatedData(item)
    }
    const [updatedData, setUpdatedData] = useState()


    const [loadingGalleryImage, setLoadingGalleryImage] = useState(false)
    const handleGalleryUpload = async (e) => {
        e.preventDefault()
        setLoadingGalleryImage(true)
        const { name, files } = e.target;
        if (files && files.length > 0) {
            // File is selected, perform image upload
            const formData = new FormData();
            formData.append("image", files[0]);
            const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                // Update state with the URL of the uploaded image

                // setNonMemberProfileAdd.gallery(prev => ({
                //     ...prev,
                //     [name]: res?.data?.url
                // }));



                setUpdatedData({ ...updatedData, image: res?.data?.url })
                setLoadingGalleryImage(false)
            }
        }
    };

    const handleUpdateModalGallery = (e) => {
        e.preventDefault();
        setNonMemberProfileAdd((prevData) => ({
            ...prevData,
            gallery: prevData.gallery.map((item) =>
                item._id === updatedData._id
                    ? {
                        ...item,
                        title: updatedData.title,
                        shortDesc: updatedData.shortDesc,
                        image: updatedData.image,
                    }
                    : item
            ),
        }));
    }

    const handleDeleteModalGallery = (e) => {
        e.preventDefault();
        setNonMemberProfileAdd((prevData) => ({
            ...prevData,
            gallery: prevData.gallery.filter((item) => item._id !== updatedData._id),
        }));
    }

    //Services Multi Select

    const [serviceOptions, setServiceOptions] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([]);

    const getCompanyTypeWiseServices = async (id) => {
        try {
            const res = await HttpClient.requestData(
                "companyType-wise-service/" + id,
                "GET",
                {}
            );

            if (res?.status) {

                const filteredData = res.data.filter(
                    // (item) => !NonMemberProfileAdd.businessProductCatId.includes(item._id)
                    (item) => !selectedOptions.includes(item.value)
                );

                setServiceOptions(filteredData.map((item) => ({
                    value: item._id,
                    label: item.name,
                })) || []);

                /////
                const presentServiceData = res.data.filter(
                    // (item) => !UserProfileID?.businessProductCat.includes(item._id)
                    (item) => NonMemberProfileAdd.businessProductCatId.includes(item._id)
                );

                setSelectedOptions(presentServiceData.map((item) => ({
                    value: item._id,
                    label: item.name,
                })) || []);
            }
        } catch (error) {
            console.error("Error occured!", error);
        }
    };

    const handleServiceChange = (selected) => {
        setSelectedOptions(selected);
    };

    ////Keywords////

    //selectedKeywordOptions
    const [keywordOptions, setKeywordOptions] = useState([])
    const [selectedKeywordOptions, setSelectedKeywordOptions] = useState([])

    const getBusinessKeywords = async () => {
        try {
            const res = await HttpClient.requestData(
                "business-product-keyword",
                "GET"
            );

            if (res?.status) {
                const filteredData = res.data.filter(
                    // (item) => !UserProfileID?.businessProductkeywords.includes(item._id)
                    (item) => !selectedKeywordOptions.includes(item._id)
                );
                setKeywordOptions(filteredData || [])

                /////
                const presentKeywordData = res.data.filter(
                    // (item) => !UserProfileID?.businessProductCat.includes(item._id)
                    (item) => NonMemberProfileAdd.businessProductkeywordsId.includes(item._id)
                );
                setSelectedKeywordOptions(presentKeywordData || []);
            }
        } catch (error) {
            console.error("Error fetching country states:", error);
        }
    }

    const handleKeywordsChange = (event, newValue) => {
        setSelectedKeywordOptions(newValue);
    };

    return (
        <>
            <div className="d-flex justify-content-end">
                <div className="form-header">


                    <section className="piechartsBox_area bg-light">
                        <div className="container">
                            <div className="row justify-content-md-center">
                                <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                                    <h3 className="fs-6 text-secondary mb-2 text-uppercase text-center">
                                        Update Business Page
                                    </h3>

                                    <hr className="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle" />
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row gy-3 gy-md-4 gy-lg-0 justify-content-md-center">

                                <div className="col-12 col-lg-12">
                                    <div className="row justify-content-xl-center">
                                        <div className="col-12 col-xl-11">
                                            <div className="bg-white border rounded shadow-sm overflow-hidden">
                                                <form action="#!">
                                                    <div className="row gy-4 gy-xl-5 p-4 p-xl-5">
                                                        {/* company type */}
                                                        <div className="col-6">
                                                            <label htmlFor="fullname" className="form-label">
                                                                Company Type <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                type="text"
                                                                className="form-control"
                                                                id="fullname"
                                                                name="companyTypeID"
                                                                value={NonMemberProfileAdd.companyTypeID}
                                                                onChange={(e) => {
                                                                    handleChange(e)
                                                                    getCompanyTypeWiseServices(e.target.value)
                                                                }}
                                                            >
                                                                <option value="" >
                                                                    Select Type of Business
                                                                </option>
                                                                {Business.map((item, i) => (
                                                                    <option key={i} value={item?._id}>
                                                                        {item?.type}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        {/* Company name */}
                                                        <div className="col-6">
                                                            <label htmlFor="fullname" className="form-label">
                                                                Company Name <span className="text-danger">*</span>
                                                            </label>
                                                            <input

                                                                className="form-control"
                                                                type="text"
                                                                name="companyName"
                                                                value={NonMemberProfileAdd.companyName}
                                                                placeholder="Company Name"
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        {/* Logo */}
                                                        <div className="col-3">
                                                            <label htmlFor="logo" className="form-label" style={{ display: "block" }}>
                                                                Company Logo
                                                            </label>
                                                            {
                                                                isUploadingLogo ?
                                                                    <Oval
                                                                        height={80}
                                                                        width={80}
                                                                        color="#4fa94d"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass=""
                                                                        visible={true}
                                                                        ariaLabel='oval-loading'
                                                                        secondaryColor="#4fa94d"
                                                                        strokeWidth={2}
                                                                        strokeWidthSecondary={2}
                                                                    /> :
                                                                    <img
                                                                        src={NonMemberProfileAdd.businessProfilePic || nophoto}
                                                                        style={{ maxWidth: "100%", maxHeight: "200px", padding: "5px 0" }}
                                                                    />
                                                            }
                                                            <input
                                                                className="form-control"
                                                                type="file"
                                                                name="businessProfilePic"
                                                                // value={NonMemberProfileAdd.companyName}
                                                                onChange={(e) => handleUpload(e)}
                                                            />
                                                        </div>
                                                        {/* Banner */}
                                                        <div className="col-7">
                                                            <label htmlFor="banner" className="form-label" style={{ display: "block" }}>
                                                                Company Banner
                                                            </label>
                                                            {
                                                                isUploadingBusinesBanner ?
                                                                    <Oval
                                                                        height={80}
                                                                        width={80}
                                                                        color="#4fa94d"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass=""
                                                                        visible={true}
                                                                        ariaLabel='oval-loading'
                                                                        secondaryColor="#4fa94d"
                                                                        strokeWidth={2}
                                                                        strokeWidthSecondary={2}
                                                                    /> :
                                                                    <img
                                                                        src={NonMemberProfileAdd.businesBanner || nophoto}
                                                                        style={{ maxWidth: "100%", maxHeight: "200px", padding: "5px 0" }}
                                                                    />
                                                            }
                                                            <input
                                                                className="form-control"
                                                                type="file"
                                                                name="businesBanner"
                                                                // value={NonMemberProfileAdd.companyName}
                                                                onChange={(e) => handleUpload(e)}
                                                            />
                                                        </div>

                                                        {/* About */}
                                                        <div className="col-12 col-md-12">
                                                            <label htmlFor="email" className="form-label">
                                                                About <span className="text-danger">*</span>
                                                            </label>
                                                            <div className="input-group">
                                                                <textarea className="form-control" name="aboutBusiness" rows="3" onChange={handleChange} placeholder="A short note about the business">{NonMemberProfileAdd?.aboutBusiness || ""}</textarea>
                                                                {/* <input

                                                                className="form-control ml-1"
                                                                type="email"
                                                                name="emailId"
                                                                value={NonMemberProfileAdd.emailId}
                                                                placeholder="Email Id"
                                                                onChange={handleChange}
                                                            /> */}
                                                            </div>
                                                        </div>

                                                        {/* Services */}
                                                        <div className="col-12 col-md-12 my-3">
                                                            <label htmlFor="services" className="form-label">
                                                                Services
                                                            </label>
                                                            <Select
                                                                options={serviceOptions}
                                                                isMulti
                                                                value={selectedOptions}
                                                                onChange={handleServiceChange}
                                                                placeholder="Select services..."
                                                            />
                                                        </div>

                                                        {/* Keywords */}
                                                        <div className="col-12 col-md-12 my-3">
                                                            <label htmlFor="keywords" className="form-label">
                                                                Keywords
                                                            </label>
                                                            <Autocomplete
                                                                multiple
                                                                options={keywordOptions}
                                                                getOptionLabel={(option) => option.keyword}
                                                                value={selectedKeywordOptions}
                                                                onChange={handleKeywordsChange}
                                                                isOptionEqualToValue={(option, value) => option._id === value._id}
                                                                renderTags={(value, getTagProps) =>
                                                                    value.map((option, index) => (
                                                                        <Chip
                                                                            key={option.id}
                                                                            label={option.keyword}
                                                                            {...getTagProps({ index })}
                                                                        />
                                                                    ))
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField {...params} label="Select keywords" placeholder="Type to search" />
                                                                )}
                                                            />
                                                        </div>

                                                        {/* Gallery */}
                                                        <div className="col-12">
                                                            <div className='row'>
                                                                {
                                                                    NonMemberProfileAdd?.gallery.map((item, key) => {
                                                                        return (
                                                                            <>
                                                                                <div className="col-3">

                                                                                    {
                                                                                        <img
                                                                                            src={item.image || nophoto}
                                                                                            style={{ maxWidth: "100%", maxHeight: "200px", padding: "5px 0" }}
                                                                                            onClick={(e) => { editGallery(e, item) }}
                                                                                            data-toggle="modal" data-target="#galleryImageEditModal"
                                                                                        />
                                                                                    }
                                                                                    <label htmlFor="logo" className="form-label" style={{ display: "block" }}>
                                                                                        {item.title}
                                                                                    </label>
                                                                                    {/* <input
                                                                                    className="form-control"
                                                                                    type="file"
                                                                                    name="businessProfilePic"
                                                                                    onChange={(e) => handleUpload(e)}
                                                                                /> */}
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* phone number */}
                                                        <div className="col-6 col-md-6 my-3">
                                                            <label htmlFor="phone" className="form-label">
                                                                Phone Number
                                                            </label>
                                                            <div className="input-group">
                                                                {/* <span className="input-group-text">
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width={16}
                                                                        height={16}
                                                                        fill="currentColor"
                                                                        className="bi bi-telephone"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                                                    </svg>
                                                                </span> */}
                                                                <select
                                                                    type="tel"
                                                                    className="form-control col-4 mr-1 ml-1"
                                                                    name="countryCodeMobile"
                                                                    value={NonMemberProfileAdd.countryCodeMobile}
                                                                    onChange={handleChange}

                                                                >
                                                                    {Country.map((item, i) => (
                                                                        <option key={i} value={item?.phone_code}>
                                                                            {item?.emoji} {item?.phone_code}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="telephoneNo"
                                                                    value={NonMemberProfileAdd.telephoneNo.split(" ")[1] || NonMemberProfileAdd.telephoneNo}
                                                                    onChange={handleNumberChange}
                                                                    placeholder="Phone Number "

                                                                />
                                                            </div>
                                                        </div>
                                                        {/* mobile number */}
                                                        <div className="col-6 col-md-6 my-3">
                                                            <label htmlFor="phone" className="form-label">
                                                                Mobile Number
                                                            </label>
                                                            <div className="input-group">
                                                                {/* <span className="input-group-text">
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width={16}
                                                                        height={16}
                                                                        fill="currentColor"
                                                                        className="bi bi-telephone"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                                                    </svg>
                                                                </span> */}
                                                                <select
                                                                    type="tel"
                                                                    className="form-control col-4 mr-1 ml-1"
                                                                    name="countryCodeMobile"
                                                                    value={NonMemberProfileAdd.countryCodeMobile}
                                                                    onChange={handleChange}

                                                                >
                                                                    {Country.map((item, i) => (
                                                                        <option key={i} value={item?.phone_code}>
                                                                            {item?.emoji} {item?.phone_code}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="mobileNo"
                                                                    value={NonMemberProfileAdd.mobileNo.split(" ")[1] || NonMemberProfileAdd.mobileNo}
                                                                    onChange={handleNumberChange}
                                                                    placeholder="Mobile Number "

                                                                />
                                                            </div>
                                                        </div>
                                                        {/* whatsapp number */}
                                                        {/* <div className="col-6 col-md-6">
                                                            <label htmlFor="phone" className="form-label">
                                                                Whatsapp Number
                                                            </label>
                                                            <div className="input-group">
                                                                <span className="input-group-text">
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width={16}
                                                                        height={16}
                                                                        fill="currentColor"
                                                                        className="bi bi-telephone"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M13.601 2.399A7.94 7.94 0 0 0 8 0a7.94 7.94 0 0 0-5.601 2.399A7.94 7.94 0 0 0 0 8c0 1.299.312 2.564.902 3.694L0 16l4.305-1.158A7.94 7.94 0 0 0 8 16c2.136 0 4.141-.832 5.601-2.399A7.94 7.94 0 0 0 16 8a7.94 7.94 0 0 0-2.399-5.601zm-1.384 10.177c-.298.298-.622.552-.972.765a6.804 6.804 0 0 1-2.938.897h-.001c-1.014 0-2.013-.197-2.94-.583L3.5 14.5l.433-1.581c-.333-.952-.502-1.943-.502-2.946 0-1.94.757-3.764 2.143-5.143A7.14 7.14 0 0 1 8 3c1.94 0 3.764.757 5.143 2.143A7.14 7.14 0 0 1 15.5 8c0 1.94-.757 3.764-2.143 5.143zm-2.434-4.318c-.075-.047-.517-.254-.598-.283-.08-.03-.138-.046-.197.046-.058.093-.226.283-.278.34-.052.058-.102.065-.19.023-.087-.042-.366-.135-1.39-.79-.512-.308-.857-.693-.957-.81-.1-.116-.1-.173-.019-.28.08-.107.108-.18.166-.28.057-.1.027-.17-.015-.237-.042-.066-.389-.93-.532-1.274-.14-.334-.284-.288-.39-.293-.1-.004-.172-.01-.264-.01-.091 0-.238.034-.363.16-.125.126-.478.467-.478 1.145 0 .677.49 1.332.558 1.425.07.093.972 1.485 2.353 2.084.329.142.586.227.787.29.33.105.63.09.87.055.265-.04.82-.333.937-.654.116-.322.116-.598.081-.654-.034-.058-.128-.093-.266-.162z" />
                                                                    </svg>

                                                                </span>
                                                                <select
                                                                    type="tel"
                                                                    className="form-control col-2 mr-1 ml-1"
                                                                    name="countryCodewhatsappNo"
                                                                    value={NonMemberProfileAdd.countryCodewhatsappNo}

                                                                    onChange={handleChange}

                                                                >
                                                                    {Country.map((item, i) => (
                                                                        <option key={i} value={item?.phone_code}>
                                                                            {item?.emoji} {item?.phone_code}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="phone"
                                                                    name="whatsappNo"
                                                                    value={NonMemberProfileAdd.whatsappNo}
                                                                    placeholder='Whatsapp Number'
                                                                    onChange={handleNumberChange}

                                                                />
                                                            </div>
                                                        </div> */}

                                                        {/* Website */}
                                                        <div className="col-6 col-md-6">
                                                            <label htmlFor="phone" className="form-label">
                                                                Website
                                                            </label>
                                                            <div className="input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="businessWebsiteLink"
                                                                    value={NonMemberProfileAdd.businessWebsiteLink}
                                                                    placeholder='Website address'
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Location */}
                                                        <div className="col-6 col-md-6">
                                                            <label htmlFor="location" className="form-label">
                                                                Location
                                                            </label>
                                                            <div className="input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="businessLocationLink"
                                                                    value={NonMemberProfileAdd.businessLocationLink}
                                                                    placeholder='Location URL'
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Facebook */}
                                                        <div className="col-12 col-md-12 mt-3">
                                                            {/* <label htmlFor="location" className="form-label">
                                                                Facebook
                                                            </label> */}

                                                            <div className="input-group">
                                                                <i className="fa fa-2x fa-facebook-f mr-2"></i>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="businessFacebookLink"
                                                                    value={NonMemberProfileAdd.businessFacebookLink}
                                                                    placeholder='Facebook URL'
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Instagram */}
                                                        <div className="col-12 col-md-12 mt-3">
                                                            {/* <label htmlFor="location" className="form-label">
                                                                instagram
                                                            </label> */}

                                                            <div className="input-group">
                                                                <i className="fa fa-2x fa-instagram mr-2"></i>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="businessInstaLink"
                                                                    value={NonMemberProfileAdd.businessInstaLink}
                                                                    placeholder='Instagram URL'
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* LinkedIn */}
                                                        <div className="col-12 col-md-12 mt-3">
                                                            {/* <label htmlFor="location" className="form-label">
                                                                instagram
                                                            </label> */}

                                                            <div className="input-group">
                                                                <i className="fa fa-2x fa-linkedin mr-2"></i>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="businessLinkedInLink"
                                                                    value={NonMemberProfileAdd.businessLinkedInLink}
                                                                    placeholder='LinkedIn URL'
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-12 mt-3">
                                                            <div className="d-flex justify-content-end">
                                                                <button className="btn btn-primary btn-sm" type="submit" onClick={(e) => handleSubmit(e)}>
                                                                    Save Changes
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

            </div>


            <div id="galleryImageEditModal" className="modal" tabindex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{updatedData?.title}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {
                                loadingGalleryImage ?
                                    <Oval
                                        height={80}
                                        width={80}
                                        color="#4fa94d"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                        visible={true}
                                        ariaLabel='oval-loading'
                                        secondaryColor="#4fa94d"
                                        strokeWidth={2}
                                        strokeWidthSecondary={2}
                                    />
                                    :
                                    <img src={updatedData?.image} style={{ width: "100%" }} />
                            }

                            <input
                                className='form-control my-3'
                                type='file'
                                onChange={(e) => handleGalleryUpload(e)}
                            />
                            <input type="text" className='form-control my-3'
                                value={updatedData?.title || ""}
                                placeholder='Enter title'
                                onChange={(e) => setUpdatedData({ ...updatedData, title: e.target.value })}
                            />
                            <textarea className='form-control my-3' rows='3'
                                value={updatedData?.shortDesc || ""}
                                placeholder='Enter short description'
                                onChange={(e) => setUpdatedData({ ...updatedData, shortDesc: e.target.value })}
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-sm btn-primary" data-dismiss="modal"
                                onClick={(e) => handleUpdateModalGallery(e)}
                            >Update</button>
                            <button type="button" className="btn btn-sm btn-danger" data-dismiss="modal"
                                onClick={(e) => handleDeleteModalGallery(e)}
                            >Remove</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default MemberBusinessListEdit